import { PollWithResults } from '@core/types';
import { onDemandVoteOnPoll, useAppDispatch, voteOnPoll } from '@online-webinar/store';
import { useState } from 'react';
import { SSPollAnswer } from '../SSPollAnswer';

interface Props {
    poll: PollWithResults;
    shown: boolean;
    isOnDemand?: boolean;
}

export const SSPollAnswers = ({ poll, shown, isOnDemand }: Props) => {
    const [selectedOption, setSelectedOption] = useState('');
    const dispatch = useAppDispatch();
    const onClickAnswer = (optionId: string) => {
        setSelectedOption(optionId);
        if (isOnDemand) {
            dispatch(onDemandVoteOnPoll({ pollId: poll.pollId, optionId }));
        } else {
            dispatch(voteOnPoll({ pollId: poll.pollId, optionId }));
        }
    };

    const slideAnimationClass = shown
        ? 'transition-opacity opacity-100 duration-500 translate-x-0 right-0 duration-300 ease-in-out transform translate-x-0'
        : 'transition-all delay-500 opacity-0 translate-x-full right-0 duration-300 ease-in-out transform translate-x-full';

    return (
        <div className={`w-full min-h-0 bg-white shadow-5xl overflow-y-auto overscroll-y-contain p-0 ${slideAnimationClass}`} data-testid="PollAnswers">
            {poll.options.map((option, index) => (
                <SSPollAnswer
                    classNames={option.optionId === selectedOption && 'bg-primary text-on-primary'}
                    key={`poll-answer-${index}`}
                    index={index}
                    answer={option.text}
                    onClick={() => onClickAnswer(option.optionId)}
                />
            ))}
        </div>
    );
};
